import { isEmpty } from 'lodash'
import { locationListForEntity, deleteLocation } from '@/libs/api/api'
import { message, loader, logout, errorHandler } from '@/libs/helper'
import constants from '@/libs/constant/constants'
// import pageRoute from '@/libs/constant/pageRoutes'
import {mapGetters} from 'vuex'

export default {
    name: 'ShortURLSettings',
    props: {
        organisationList: {
            type: Array,
            default: () => []
        },
        details: {
            type: Object,
            default: () => {}
        },

        changeOrganisation: {
            type: Function,
            default: () => {}
        }
    },

    computed: {
        ...mapGetters({
            userInformation: 'getUserInformation',
            locations: 'getLocations'
        }),
    },

    watch: {
        details (newValue) {
            if ( !isEmpty(newValue) ) {
                // fetch active urls
                this.fetchLocations()
            }
        },
        '$route' (to, from) {
            if (to.path !== from.path) {
                this.fetchLocations()
            }
        }
    },
    mounted () {
    },

    data () {
        return {
            isEmpty,
            showDropdown: false,
        }
    },
    methods: {
       /**
         * to fetch locations
         */
        fetchLocations () {
            if (!this.details._id) return
            // api call
            locationListForEntity(this.details._id, {child_structure: true})
            .then(response => {
                this.$store.dispatch('setLocations', (response.result || []))
            }).catch(error => console.error(error))
            
        },

        /**
         * remove tree item
         * @param {*} node 
         * @param {*} data 
         */
         async removeLocation (data) {
            try {
                loader(this, true)
                // delete loc
                let response = await deleteLocation(data._id)

                // fetch locations
                this.fetchLocations(true)
                message(this, constants.messageType.SUCCESS, response.message)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)));
            }
            finally {
                loader(this, false)
            }

        },
    }
}